import { useMemo } from 'react';
import { useIntl } from 'react-intl';

const PERIOD_MONTHS = {
  THREE: 3,
  SIX: 6,
  TWELVE: 12,
  TWENTY_FOUR: 24
} as const;

/**
 * Custom hook to generate period options for the period filter dropdown, with internationalized labels
 * @returns An array of period options with value and name properties
 */
export const usePeriodOptions = () => {
  const intl = useIntl();

  return useMemo(
    () => [
      {
        value: 'this-month',
        name: intl.formatMessage({ id: 'reporting.period.this_month', defaultMessage: 'This month' })
      },
      {
        value: 'last-month',
        name: intl.formatMessage({ id: 'common.last_month', defaultMessage: 'Last month' })
      },
      {
        value: 'last-3-months',
        name: intl.formatMessage(
          { id: 'predict.last_n_months', defaultMessage: 'Last {n} months' },
          { n: intl.formatNumber(PERIOD_MONTHS.THREE) }
        )
      },
      {
        value: 'last-6-months',
        name: intl.formatMessage(
          { id: 'predict.last_n_months', defaultMessage: 'Last {n} months' },
          { n: intl.formatNumber(PERIOD_MONTHS.SIX) }
        )
      },
      {
        value: 'last-12-months',
        name: intl.formatMessage(
          { id: 'predict.last_n_months', defaultMessage: 'Last {n} months' },
          { n: intl.formatNumber(PERIOD_MONTHS.TWELVE) }
        )
      },
      {
        value: 'last-24-months',
        name: intl.formatMessage(
          { id: 'predict.last_n_months', defaultMessage: 'Last {n} months' },
          { n: intl.formatNumber(PERIOD_MONTHS.TWENTY_FOUR) }
        )
      }
    ],
    [intl]
  );
};
